<template>
  <v-sheet
    id="register"
    class="fill-height d-flex justify-space-around"
  >          
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>
    <v-overlay opacity="0">
      <v-card style="max-width: 350px" color="#ffffff00" elevation="0" class="mt-0">
        <v-img
          src="../assets/flat.png"
          height="200"
          contain
          >
        </v-img>

        <v-form v-if="!successful" ref="form" v-model="valid" lazy-validation name="form">
          <v-text-field
            light
            color="#2A353D"
            prepend-inner-icon="mdi-account"
            v-model="user.UserID"
            label="Username"
            outlined
            required
            :rules="userNameRules"
            @keyup.enter="handleRegister()"
          ></v-text-field>

          <v-text-field
            light
            color="#2A353D"
            prepend-inner-icon="mdi-account"
            v-model="user.FullName"
            label="Full Name"
            outlined
            required
            :rules="fullNameRules"
            @keyup.enter="handleRegister()"
          ></v-text-field>

          <v-text-field
            light
            color="#2A353D"
            prepend-inner-icon="mdi-email"
            v-model="user.Email"
            type="email"
            label="Email"
            outlined
            required
            :rules="emailRules"
            @keyup.enter="handleRegister()"
          ></v-text-field>

          <v-text-field
            light
            color="#2A353D"
            prepend-inner-icon="mdi-lock"
            v-model="user.Password"
            type="password"
            label="Password"
            outlined
            required
            :rules="passwordRules"
            @keyup.enter="handleRegister()"
          ></v-text-field>

          <v-btn :disabled="!valid" @click="handleRegister()" class="btn btn-primary btn-block" color="#2A353D">
            <span class="white--text font-weight-bold">SUBMIT</span>
          </v-btn>

          <div class="text-center black--text caption mt-1">Already have an account? <router-link to="/login"> Login </router-link></div>
        </v-form>
        <span v-else class="subtitle-2 grey--text text-center">Done! Please check your email for confirmation link</span>
      </v-card>
    </v-overlay>
  </v-sheet>
</template>

<script>
import User from '../models/user';

export default {
  name: 'Register',

  data() {
    return {
      user: new User('', '', '', ''),
      submitted: false,
      successful: false,
      message: '',
      valid: true,
      userNameRules: [
        v => !!v || 'username is required',
        v => (v && v.length <= 10) || 'username must be less than 10 characters',
        v => (v && v.length >= 3) || 'username must be at least 3 characters',
      ],
      fullNameRules: [
        v => !!v || 'Full name is required',
        v => (v && v.length >= 3) || 'username must be at least 3 characters',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: [
        v => !!v || 'password is required',
        v => (v && v.length >= 6) || 'password must be at least 6 characters',
      ],
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  // mounted() {
  //   if (this.loggedIn) {
  //     this.$router.push('/profile');
  //   }
  // },
  methods: {
    async handleRegister() {
      this.message = '';
      this.submitted = true;
      await this.validate();

      if(this.valid == true){
        this.$store.dispatch('auth/register', this.user).then(
          data => {
            this.message = data.message;
            this.successful = true;
            this.reset();
          },
          error => {
            this.message =
              (error.response && error.response.data.message) ||
              error.message ||
              error.toString();
            this.successful = false;
        });
      }
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
    },

    reset () {
      this.$refs.form.reset()
    },
  },
};
</script>

<style scoped>
#register {
  background-color: white;
}

.v-btn {
  outline: none
}

.text {
  color: #1C284E;
}

.card {
  background-color: white;
}

</style>